<template>
  <div class="bg-for-you">
  </div>
</template>

<style type="text/css" scoped>
  .bg-for-you {
    margin: -100px -20px -50px;
  }

  .img-for-you {
    background-image: url(../../assets/img/img-you.svg);
  }

  @media only screen and (max-width: 1279px) {
    .bg-for-you {
      margin: -50px -20px;
    }
  }

  @media screen and (max-width: 480px) {
    .bg-for-you {
      margin: -20px -20px -50px;
    }
  }
</style>

<script>
const wideSvg = require('!!raw-loader!../../assets/img/img-you.svg');
const mobSvg = require('!!raw-loader!../../assets/img/img-you-mob.svg');

export default {
  data() {
    return {}
  },
  created(){
  },

  mounted() {
    this.resize();
  },

  methods:{
    resize(){
      let vm = this;
      let svgW = $(wideSvg);
      let svgM = $(mobSvg);

      if($(window).width() < 750)
        svgM.appendTo(this.$el);
      else
        svgW.appendTo(this.$el);

    }
  }
}

</script>



// WEBPACK FOOTER //
// for-you.vue?55ff34d4